import React, { Component } from "react";
import styled from "styled-components";

// COMPONENTS
import { NanoFlex } from "../NanoFlex.js";
import Type from "../Typography.js";

// IMAGES
import { ReactComponent as AirQuality } from "../../../images/Metrics/airQuality.svg";
import { ReactComponent as Energy } from "../../../images/Metrics/energy.svg";
import { ReactComponent as Humidity } from "../../../images/Metrics/humidity.svg";
import { ReactComponent as Illuminance } from "../../../images/Metrics/illuminance.svg";
import { ReactComponent as Noise } from "../../../images/Metrics/noise.svg";
import { ReactComponent as Temperature } from "../../../images/Metrics/temperature.svg";
import { ReactComponent as Inactivity } from "../../../images/Metrics/inactivity.svg";

const StyledMetrics = styled(NanoFlex)`
  cursor: pointer;
  opacity: 0.4;
  max-height: 20px;

  &:hover {
    opacity: 1;
  }

  .metricName {
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0.2px;
    color: #252733;
    margin-left: 10px;
    padding-bottom: 3px;
    border-bottom: 3px solid transparent;

    &:hover {
      border-bottom: 3px solid ${(props) => props.borderColor};
    }
  }

  &.active {
    opacity: 1;
    .metricName {
      border-bottom: 3px solid ${(props) => props.borderColor};
    }
  }
`;

class Metric extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: this.props.value ?? "NEED TEXT",
      color: this.props.color,
      active: this.props.active ?? false,
    };
  }

  render() {
    return (
      <StyledMetrics
        borderColor={this.state.color}
        className={this.props.active ? "active" : ""}
        onClick={(e) => this.props.onSelectMetric(this.props.id)}
      >
        <NanoFlex justifyContent="flex-start">
          <NanoFlex
            color={this.state.color}
            radius={"20px"}
            padding={"10px"}
            height={"20px"}
            width={"20px"}
          >
            {this.state.text === "Temperature" ? (
              <Temperature></Temperature>
            ) : this.state.text === "Humidity" ? (
              <Humidity></Humidity>
            ) : this.state.text === "Air Quality" ? (
              <AirQuality></AirQuality>
            ) : this.state.text === "Inactivity" ? (
              <Inactivity></Inactivity>
            ) : this.state.text === "Iluminance" ? (
              <Illuminance></Illuminance>
            ) : this.state.text === "Noise" ? (
              <Noise></Noise>
            ) : (
              <Energy></Energy>
            )}
          </NanoFlex>
          <Type.p className="metricName">
            <b>{this.state.text}</b>
          </Type.p>
        </NanoFlex>
      </StyledMetrics>
    );
  }
}

export default Metric;
